import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeSelectGuestOrder, makeSelectUserOrders } from "ducks/selectors";
import { get, isEmpty, isEqual } from "lodash";
import { gotoUrl, pathWithChannel, urlParam } from "utils/helpers";
import { setData } from "ducks/actions";
import {
  publicPaths,
  SIGNINTYPE_PATHS,
  SIGNINTYPE,
  paths
} from "utils/constants";
import find from "lodash/find";
import { fetchUserOrders } from "ducks/actions";
import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * A custom hook to select the order based on the order ref from user order and if user order present take the user to login screen,
 if no user current select order present and user order is present take the user to order list page.
 * @returns {selectOrderandNavigate:Function }
 */
const useSelectOrder = () => {
  const dispatch = useDispatch();
  const orderRef = urlParam("order_ref") || urlParam("orderRef");
  const currentSelectedOrder = useSelector(makeSelectGuestOrder(), isEqual);
  const userOrders = useSelector(makeSelectUserOrders(), isEqual);
  const [selectOrder, setSelectOrder] = useState(false);
  const { effEnableSimActivationV2Redirections = false } = useFlags();

  useEffect(() => {
    if (!isEmpty(userOrders)) {
      setSelectOrder(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(userOrders)]);

  function selectOrderandNavigate() {
    if (!isEmpty(userOrders)) {
      const currentOrder = find(userOrders, { order_ref: orderRef });
      if (
        (!isEmpty(currentOrder) &&
          get(currentSelectedOrder, "orderRef") !==
            get(currentOrder, "order_ref")) ||
        (!isEmpty(currentOrder) && selectOrder)
      ) {
        setSelectOrder(false);
        dispatch(
          setData({ key: "guestOrder", data: currentOrder, override: true })
        );
      } else if (selectOrder) {
        setSelectOrder(false);
        const order = find(userOrders, {
          order_ref: get(currentSelectedOrder, "orderRef")
        });
        dispatch(setData({ key: "guestOrder", data: order, override: true }));
      } else if (isEmpty(currentSelectedOrder)) {
        return gotoUrl(paths.MY_ORDERS);
      }
    } else {
      dispatch(fetchUserOrders({}, orders => {
        if(!effEnableSimActivationV2Redirections && !isEmpty(orders)){
          setSelectOrder(true);
        } else {
          return gotoUrl(
            pathWithChannel(
              publicPaths.LOGIN_PAGE.replace(SIGNINTYPE, SIGNINTYPE_PATHS.LOGIN),
              "web"
            ),
            {},
            {},
            false
          );
        }
      }))
    }
  }

  return selectOrderandNavigate;
};

export default useSelectOrder;
